module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABO0lEQVRYhb3YWWrDMBCA4d9pjtOnHqENOUMP0Dt0fWwW6LGaS3WBFIEFQpXkWaQMGGwZxMdoLFmaPh7uccYjMAFHTzfrDogUYMasOiIOwNOlITnCjbFAaggXRgspId7my4XRFGsNsUue3zMM0gK+2t5c90J8Ar/AbdK2Ab6AUw+IBOHGLEE0CBemBbEgzJgaxIMwYUqQHgg1Jof0RKgwKWQEQoyJkBLiFdh3QIgw6wshYsTs/puBV5X15jwA0ep7CkNzmtMT0hTjDviWTM3KeCnUXGg7xBqpYX7msR2KIPtqRmKaiBwyCrOIKEF6Y0SIGqQXRoxoQbwYFWIJYsWoERKIFmNCSCFSjBmB8i8+rkdpx7vKvQqhhUgwJgTGnV7APDfeqxFWSAtjQnggJYwZEcJ7PhJrJhzUmBEAf7QroVxFyOngAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/indicator.png
// module id = vqyz
// module chunks = 1